import { createContext, useContext, useState, useCallback, useRef } from "react";
import { ConfirmActionDialog } from "../components/ui/ConfirmActionDialog";

const ConfirmContext = createContext(null);

export function ConfirmActionProvider({ children }) {
  const [state, setState] = useState({ open: false, title: "", description: "", confirmText: "Confirm", variant: "warning" });
  const resolveRef = useRef(null);

  const confirmAction = useCallback(({ title = "Confirm Action", description = "Are you sure you want to proceed?", confirmText = "Confirm", variant = "warning" } = {}) => {
    return new Promise((resolve) => {
      resolveRef.current = resolve;
      setState({ open: true, title, description, confirmText, variant });
    });
  }, []);

  const handleConfirm = useCallback(() => {
    setState((s) => ({ ...s, open: false }));
    resolveRef.current?.(true);
    resolveRef.current = null;
  }, []);

  const handleOpenChange = useCallback((open) => {
    if (!open) {
      setState((s) => ({ ...s, open: false }));
      resolveRef.current?.(false);
      resolveRef.current = null;
    }
  }, []);

  return (
    <ConfirmContext.Provider value={confirmAction}>
      {children}
      <ConfirmActionDialog
        open={state.open}
        onOpenChange={handleOpenChange}
        onConfirm={handleConfirm}
        title={state.title}
        description={state.description}
        confirmText={state.confirmText}
        variant={state.variant}
      />
    </ConfirmContext.Provider>
  );
}

export function useConfirmAction() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error("useConfirmAction must be used inside ConfirmActionProvider");
  return ctx;
}
